import React, {useCallback, useEffect, useState} from "react";
import Select from "react-select";
import {reactSelectClassNames, reactSelectStyles} from "../react-select/styling";
import {noop} from "../misc/noop";
import {countries} from "@/lib/countries";

type Country = {
    countryCode: string;
    countryNameEn: string;
    flag: string;
};

type Option = {
    value: string;
    label: string;
    country: Country;
};

type CountrySelectV2Props = {
    initialValue?: string | null | undefined;
    onChange?: (selected: Country | undefined) => void;
    label?: string;
    required?: boolean;
};

export const CountrySelectV2 = ({
    initialValue = null,
    onChange = noop,
    label,
    required = false,
}: CountrySelectV2Props) => {
    const [selected, setSelected] = useState<Option | null>(null);

    const options: Option[] = countries.map((country) => ({
        value: country.countryCode,
        label: country.countryNameEn,
        country,
    }));

    useEffect(() => {
        if (!initialValue) return;
        const option = options.find((o) => o.value === initialValue);
        if (option) {
            setSelected(option);
        }
    }, [initialValue]);

    const onSelect = useCallback(
        (option: any) => {
            if (option) {
                setSelected(option);
                onChange(option.country);
            } else {
                setSelected(null);
                onChange(undefined);
            }
        },
        [onChange]
    );

    return (
        <div className="flex flex-col relative">
            {label != undefined && (
                <label className="">
                    {label}
                    {required && <span className="text-dark-red"> *</span>}
                </label>
            )}
            <Select
                classNames={reactSelectClassNames}
                styles={reactSelectStyles}
                placeholder="Select Country"
                value={selected}
                onChange={onSelect}
                options={options}
                isClearable
            />
        </div>
    );
};
